import React, { forwardRef, HTMLAttributes, MouseEventHandler } from 'react'
import classNames from 'classnames'
import { Colors } from '../types'

interface TagProps extends HTMLAttributes<HTMLDivElement|HTMLSpanElement> {
    color?: Colors
    textColor?: Colors
    shape?: 'pill'|string
    className?: string
    style?: any
}

const Tag = forwardRef<HTMLDivElement, TagProps>(({
    color,
    textColor = 'white',
    shape = 'rounded',
    className,
    style,
    children,
    ...otherProps
}, ref) => {

    const _className = classNames(
        'tag',
        {
            [`bg-${color}`]: color,
            [`text-${textColor}`]: textColor
        },
        shape,
        className
    )

    return (
        <div
            ref={ref}
            className={_className}
            style={style}
            {...otherProps}>
            <span>
                {children}
            </span>
        </div>
    )
})

export { Tag }
